import { render, staticRenderFns } from "./setlong.vue?vue&type=template&id=d2105d3a&scoped=true"
import script from "./setlong.vue?vue&type=script&lang=js"
export * from "./setlong.vue?vue&type=script&lang=js"
import style0 from "./setlong.vue?vue&type=style&index=0&id=d2105d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2105d3a",
  null
  
)

export default component.exports